const STEPS = [
  { key: "hearing", label: "ヒアリング" },
  { key: "keywords", label: "キーワード戦略" },
  { key: "assets", label: "素材管理" },
  { key: "pagePlan", label: "ページ設計" },
  { key: "approval", label: "承認" },
  { key: "publish", label: "公開" },
] as const;

export type WizardStepKey = (typeof STEPS)[number]["key"];

export function WizardSteps({ current }: { current: WizardStepKey }) {
  const currentIndex = STEPS.findIndex((s) => s.key === current);
  return (
    <ol className="wizard-steps lp-initial-progress" aria-label="初回公開までの進捗">
      {STEPS.map((step, i) => {
        const state =
          i < currentIndex ? "done" : i === currentIndex ? "current" : "todo";
        return (
          <li key={step.key} className={`wizard-step ${state}`}>
            <span className="wizard-step-num">{state === "done" ? "✓" : i + 1}</span>
            <span className="wizard-step-label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
